module.exports = "https://static.wmbcdn.com/uniweb/images/3acbcf23a01e9f46eb15ba68466a9778.svg";